import Constants from 'expo-constants';
import { Platform } from 'react-native';

import { env } from 'utils/environment';

export const country = 'CA';
export const sanityDataset = `${env()}_fhs_ca`;
export const apiKey: string = Platform.select({
  web: Constants?.expoConfig?.extra?.eas?.CA?.apiKeys?.launchDarkly,
  default: Constants?.expoConfig?.extra?.eas?.CA?.apiKeys?.launchDarklyMobileKey,
});
